import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import MasterLanding from '../Components/Master/MasterLanding';
import CoLanding from '../Components/Department/CO/CoLanding';

class CourseOutcomeContainer extends Component {
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                    <CoLanding />

                </div>
            </div>
        )
    }
}

export default withAuth(CourseOutcomeContainer);


// WEBPACK FOOTER //
// ./src/Containers/CourseOutcomeContainer.js